// extracted by mini-css-extract-plugin
export default {"container":"Design_container__yGqFH","preview":"Design_preview__qXfwm","bottom":"Design_bottom__OzbUs","icon":"Design_icon__by6Bu","addDiv":"Design_addDiv__dmcxO"};